import { RefIdentifierEditContainer } from '@/components/containers/ref-identifiers/RefIdentifierEditContainer'

const RefIdentifierRequestEditPage = () => {
    return <RefIdentifierEditContainer pageType="requests" />
}

export default RefIdentifierRequestEditPage
